import React from 'react';
import InfoIcon from '../Icons/InfoIcon';

const AddressIncompleteNotice = ({ show }) => {
  if (!show) return null;
  return (
    <div className="info-notice">
      <p>
        <InfoIcon />
        Some address fields could not be filled automatically. Please review and
        complete the fields below.
      </p>
    </div>
  );
};

export default AddressIncompleteNotice;
